// extracted by mini-css-extract-plugin
export var textInput = "TextInput-module--textInput--8ced5";